/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".before-after[_ngcontent-%COMP%]{position:relative}.before-after[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%}.before-after[_ngcontent-%COMP%]   .before-image[_ngcontent-%COMP%]{position:absolute;width:50%;overflow:hidden}.before-after[_ngcontent-%COMP%]   .slider[_ngcontent-%COMP%]{position:absolute;z-index:9;cursor:ew-resize;top:50%;left:50%;-webkit-transform:translate(-50%);transform:translate(-50%);width:40px;height:40px;background-color:#bc2524;opacity:.7;border-radius:50%}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/shared/before-after-comparison/before-after-comparison.component.scss.shim.ngstyle.js.pre-build-optimizer.js